import React, { useMemo } from "react";
import { useGetApiQuery } from "../redux/services/apiHome";
import Loader from "../components/Loader";
import InnerBannerBreadcrumb from "../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../hooks/useLanguageTranslation";
import { useParams } from "react-router-dom";
import { getLatestDateFromData } from "../Utils/utils";
import PageLastUpdated from "../components/shared/PageLastUpdated";

const VideoGalleryById = () => {
  const { id } = useParams();
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);
  const { data: videosGalleryData = [], isLoading: videosGalleryIsLoading } =
    useGetApiQuery({ url: "video-gallery", lang: languageType });
  const videoObj = videosGalleryData.find((item) => item.nid === id);

  console.log(videoObj);

  const lastUpdatedOn = useMemo(() => {
    return videoObj ? getLatestDateFromData(videoObj) : null;
  }, [videoObj]);

  if (videosGalleryIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="images/inner_aboutbann.jpg"
        title={getText("Video Gallery", "वीडियो गैलरी")}
        titleLink="/video-gallery-detail"
        // titleLink2={/}
        levelTwo={true}
        levelThree={false}
        isActive={
          videoObj?.title || getText("Video Not Found", "वीडियो नहीं मिला")
        }
        titleTwo={
          videoObj?.title || getText("Video Not Found", "वीडियो नहीं मिला")
        }
      />

      <div className="inner-container">
        <div className="container">
          <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
          {videoObj ? (
            <>
              <section className="ourCompany">
                <div className="img-sec text-center">
                  <video width="40%" height="auto" controls loop muted>
                    <source
                      src={`${process.env.REACT_APP_IMAGE_URL}/neepco/sites/default/files/2024-08/${videoObj?.field_video}`}
                      type="video/mp4"
                    />
                    {getText(
                      "Your browser does not support the video tag",
                      "आपका ब्राउज़र वीडियो टैग का समर्थन नहीं करता।"
                    )}
                  </video>
                </div>
              </section>
            </>
          ) : (
            <div className="not-found text-center py-10">
              <h2>{getText("Video Not Found", "वीडियो नहीं मिला")}</h2>
              <p>
                {getText(
                  "Please try again later.",
                  "कृपया बाद में पुनः प्रयास करें।"
                )}
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default VideoGalleryById;
